type LoadingSpinnerProps = {
  theme?: "light" | "dark";
};

export const LoadingSpinner = ({ theme = "light" }: LoadingSpinnerProps) => {
  const borderClass = theme === "light" ? "border-on-primary" : "border-ink";

  return (
    <div
      className={`h-5 w-5 animate-spin rounded-circle border-b-2 ${borderClass}`}
      aria-hidden="true"
    ></div>
  );
};
